import { render, staticRenderFns } from "./playerProBag.vue?vue&type=template&id=2cd7044a&scoped=true"
import script from "./playerProBag.vue?vue&type=script&lang=js"
export * from "./playerProBag.vue?vue&type=script&lang=js"
import style0 from "./playerProBag.vue?vue&type=style&index=0&id=2cd7044a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd7044a",
  null
  
)

export default component.exports